<template>
  <div class="box">
    <el-drawer
      :visible.sync="visible"
      :wrapperClosable="false"
      :show-close="false"
      :close-on-press-escape="false"
      custom-class="drawer1"
      :size="size"
    >
      <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">
        “
        <span style="color:red">{{title}}</span>
        ” {{aid?"":"项目"}}的媒体报道信息
      </div>

      <el-form
        :model="mediaForm"
        ref="formRef"
        label-width="100px"
        :rules="rules"
        style="margin-bottom: 80px;"
      >
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="标题" prop="title">
              <el-input
                v-model="mediaForm.title"
                size="small"
                placeholder="媒体报道标题"
                style="width:45%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col>
            <el-form-item label="报道类型" prop="type">
              <el-select v-model="mediaForm.type" placeholder="请选择报道类型">
                <el-option
                  v-for="item in mediaType"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col>
            <el-form-item label="报道级别">
              <el-radio-group v-model="mediaForm.level">
                <el-radio
                  v-for="item in levelData "
                  :key="item.value"
                  :label="item.value"
                >{{item.text}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col>
            <el-form-item label="链接地址" prop="url">
              <el-input
                v-model="mediaForm.url"
                size="small"
                placeholder="链接地址请以http://或者https://开头"
                style="width:45%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col>
            <el-form-item label="报道图片">
              <el-upload
                ref="imgUploadRef"
                :action="uploadImgUrl"
                list-type="picture-card"
                :on-preview="showImg"
                :data="uploadParms"
                name="img"
                multiple
                :before-upload="beforeUpload"
                :on-success="(response, file, fileList) =>{
                  handlerUpload(fileList,'defImg');
                    }"
                :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defImg');
                    }"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-row :gutter="20">
          <el-col>
            <el-form-item label="报道视频">
              <el-upload
                ref="videoUploadRef"
                :action="uploadFileUrl"
                :before-upload="beforeUploadFile"
                :limit="1"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">上传文件不超过300Mb</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>-->

        <el-row :gutter="20">
          <el-col>
            <el-form-item label="报道附件">
              <el-upload
                ref="fileUploadRef"
                :action="uploadFileUrl"
                style="width:40%"
                :before-upload="beforeUploadFile"
                :on-success="(response, file, fileList) =>{
                  handlerUpload(fileList,'defFiles');
                    }"
                :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defFiles');
                    }"
                :limit="1"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">上传文件不超过300Mb</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col>
            <el-form-item label="报道说明" prop="reasons">
              <el-input
                v-model="mediaForm.description"
                style="width:65%"
                type="textarea"
                :rows="4"
                placeholder="请输入媒体报道说明"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-dialog :visible.sync="img_show" append-to-body>
          <img width="100%" :src="img_url" alt />
        </el-dialog>

        <div class="demo-drawer-footer">
          <el-button type="danger" size="small" icon="el-icon-close" @click="cancelBtn">关闭</el-button>
          <el-button
            style="margin-right: 20px;"
            type="primary"
            size="small"
            icon="el-icon-check"
            @click="submitBtn"
            :loading="loading"
          >提交</el-button>
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "项目信息"
    },
    size: {
      type: [String, Number],
      default: "80%"
    },
    id: {
      type: [String, Number],
      default: null
    },
    aid: {
      type: [String, Number],
      default: null
    },
    type: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      visible: false,
      loading: false,
      defImg: [],
      defFiles: [],

      uploadParms: { file_type: 2 }, //图片上传所需参数
      img_url: null,
      img_show: false,

      mediaForm: {
        project_type: 2,
        project_id: null,
        level: 1,
        type: null,
        vedio: null,
        pic: [],
        file: null,
        description: ""
      },
      mediaType: [],
      levelData: [], //报道级别
      rules: {
        //媒体报道
        title: [
          { required: true, message: "请输入报道标题！", trigger: "blur" }
        ],
        type: [
          {
            required: true,
            type: "number",
            message: "请选择报道类型！",
            trigger: "blur,change"
          }
        ],
        url: [
          { type: "url", message: "请填写正确的链接地址！", trigger: "blur" }
        ]
      }
    };
  },

  watch: {
    visible(val) {
      this.$emit("input", val);
    },

    value: {
      handler(val) {
        this.visible = val;
      },
      immediate: true
    }
  },
  methods: {
    cancelBtn() {
      this.visible = false;
    },

    handlerUpload(fileList, name) {
      this.$set(this, name, []);
      this.$set(this, name, fileList);
    },

    //预览图片
    showImg(file) {
      this.img_url = file.url;
      this.img_show = true;
    },

    //图片上传前操作
    beforeUpload(file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },
    beforeUploadFile(file) {
      let bool = this.$fnc.checkUploadFile(file);
      return bool;
    },

    //提交操作
    submitBtn() {
      this.loading = true;
      this.mediaForm.project_type = this.type;
      if (this.defImg && this.defImg.length > 0) {
        
        let arr = [];
        for (const item of this.defImg) {
          if (item.hasOwnProperty("response")) {
            arr.push(item.response.data.id);
          } else {
            arr.push(item.id);
          }
        }
        this.mediaForm.pic = arr;
      } else {
        this.mediaForm.pic = [];
      }

      // if (this.$refs.videoUploadRef && this.$refs.videoUploadRef.uploadFiles.length > 0) {
      //   for (const item of this.$refs.videoUploadRef.uploadFiles) {
      //     let arr = [];
      //       if (item.hasOwnProperty("response")) {
      //         arr.push(item.response.data.id);
      //       } else {
      //         arr.push(item.id);
      //       }
      //     }
      //   this.mediaForm.video = arr;
      // }else{
      //   this.mediaForm.video = [];
      // }

      if (this.defFiles && this.defFiles.length > 0) {
        let arr = [];
        for (const item of this.defFiles) {
          if (item.hasOwnProperty("response")) {
            arr.push(item.response.data.id);
          } else {
            arr.push(item.id);
          }
        }
        this.mediaForm.file = arr[0];
      } else {
        this.mediaForm.file = [];
      }

      if (this.aid > 0) {
        this.mediaForm.apply_id = this.aid;
      }

      this.$refs["formRef"].validate(valid => {
        if (valid) {
          this.$db
            .post(this.$db.config.addMediaCoverage, this.mediaForm)
            .then(res => {
              this.loading = false;
              if (res && res.code == 200) {
                this.$message.success(res.msg);
                this.cancelBtn();
                this.$emit("success");
              }
            });
        } else {
          this.loading = false;
          return this.$message.warning("请填写完整信息！");
        }
      });
    },

    //获取字典表数据
    getDictInfo() {
      this.$db
        .post(this.$db.config.getDictParam, { pid: 100470, table: "pub_dict" })
        .then(res => {
          if (res && res.code == 200) {
            this.levelData = res.data;
          }
        });

      this.$db
        .post(this.$db.config.getDictParam, { pid: 200304, table: "pub_dict" })
        .then(res => {
          if (res && res.code == 200) {
            this.mediaType = res.data;
          }
        });
    }
  },
  created() {
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;
    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;
    if (this.id > 0) {
      this.getDictInfo();
      this.mediaForm.project_id = this.id;
    }
  }
};
</script>
<style lang="scss" scoped>
.box /deep/ .drawer1 {
  overflow: auto;
}
.demo-drawer-footer {
  width: 80%;
  position: fixed;
  bottom: 0;
  right: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 0px;
  text-align: right;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/info/media.vue